import MainLoading from "./MainLoading";

export default MainLoading;
